import { DayLabel, Text } from '@shared/components'
import { Col, Flex, Row } from 'antd'
import { useTranslation } from 'react-i18next'

import { ActivityLogAvatar } from './ActivityLogAvatar'
import { ActivityLogProps } from './types'
import { useGetTranslatedDescription } from './useGetTranslatedDescription'

export const ActivityLogLeadChange = ({ log }: ActivityLogProps) => {
  const { t } = useTranslation()
  const translatedDescription = useGetTranslatedDescription({ log })

  return (
    <Row justify="space-between" align="middle" gutter={[16, 16]}>
      <Col xs={24} xl={12} xxl={12}>
        <Text isEllipsis>{translatedDescription}</Text>
      </Col>

      <Col xs={24} xl={12} xxl={12}>
        <Flex gap={8} wrap justify="end" align="center">
          <ActivityLogAvatar
            user={log?.created_by}
            label={t('task.created_by')}
          />

          <DayLabel date={log?.created_at} />
        </Flex>
      </Col>
    </Row>
  )
}
